import Helpers from '@helpers';
import * as _ from 'underscore';

interface Price {
    ID: number;
    PriceDescription: string;
    Price: number;
    PriceString: string;
    FormattedPrice: string;
    CalculatedPrice: number;
    CalculatedPriceString: string;
    HasDiscount: boolean;
    IsBuyable: boolean;
    ProductColorID: number;
    ProductColorTitle: string;
    ProductColorCode: string;
    ProductColorCodeRGB: string;
    WarrantyID: number;
    WarrantyTitle: string;
    WarrantyTooltip: string;
    WarrantyLink: string;
    Discount: number;
    DiscountTitle: string;
    CorporateDiscount: number;
    CorporateDiscountTitle: string;
    ShopID: number;
    ShopTitle: string;
    ExpressShipping: boolean;
    GovId: string;
}

// Handlers
function colorClickHandler() {
    const selector = '.color-select-button';
    $(selector).off('click');
    $(selector).on('click', function() {
        $(selector).removeClass('selected');
        $(this).addClass('selected');
        LoadWarranties();
    });
    var optionList = $(selector);
    var optionNum = optionList.length;
    if (optionNum == 1) {
        optionList.css('cursor', 'default');
    }
}

function warrantyClickHandler() {
    const selector = '.warranty-select-button';
    $(selector).off('click');
    $(selector).on('click', function() {
        $(selector).removeClass('selected');
        $(this).addClass('selected');
        LoadSellers();
    });
    var optionList = $(selector);
    var optionNum = optionList.length;
    if (optionNum == 1) {
        optionList.css('cursor', 'default');
    } 
}

function sellerClickHandler() {
    const selector = '.seller-select-button';
    $(selector).off('click');
    $(selector).on('click', function() {
        $(selector).removeClass('selected');
        $(this).addClass('selected');
        LoadVariations();
    });
    var optionList = $(selector);
    var optionNum = optionList.length;
    if (optionNum == 1) {
        optionList.css('cursor', 'default');
    }
}

function variationClickHandler() {
    const selector = '.variation-select-button';
    $(selector).off('click');
    $(selector).on('click', function() {
        $(selector).removeClass('selected');
        $(this).addClass('selected');
        UpdatePrice();
        UpdateRegistryMeta();
        UpdateExpressShipping();
        UpdateGovermentId();
    });
    var optionList = $(selector);
    var optionNum = optionList.length;
    if (optionNum == 1) {
        optionList.css('cursor', 'default');
    }
}

function orderCountClickHandler() {
    const selector = '.order-count > i';
    $(selector).off('click');
    $(selector).on('click', function() {
        const span = $('.order-count > span');
        const val = +span.text();
        if ($(this).data('action') === 'increase') {
            span.text((val + 1) + '');
        } else {
            if (val > 1) {
                span.text((val - 1) + '');
            }
        }
        $('#hfdOrderCount').val(span.text());
        UpdatePrice();
    });
}

// Helpers
function LoadColors() {
    let html = '';
    const data = getData();
    if (!data) return;

    const groupedByColorId = {};
    data.forEach(x => {
        const current = groupedByColorId[x.ProductColorID];
        if (!current) {
            groupedByColorId[x.ProductColorID] = [x];
        } else {
            current.push(x);
        }
    });

    const minPrices = {};
    Object.keys(groupedByColorId).forEach((key, index) => {
        const items = groupedByColorId[key];
        const minPrice = Math.min.apply(Math, items.map(x => x.CalculatedPrice));
        minPrices[key] = minPrice;
    });

    const itemsWithMinPrice = [];
    Object.keys(minPrices).forEach((key, index) => {
        itemsWithMinPrice.push({
            minPrice: minPrices[key],
            items: groupedByColorId[key]
        });
    });

    itemsWithMinPrice.sort((a, b) => a.minPrice - b.minPrice);

    itemsWithMinPrice.forEach((current, index) => {
        const firstItemInGroup = current.items[0];
        if (firstItemInGroup.ProductColorID != undefined && firstItemInGroup.ProductColorID != 0)
        {
        // Title
        let title = 'نامشخص';
        if (firstItemInGroup.ProductColorID > 0) {
            title = firstItemInGroup.ProductColorTitle;
        }

        // ClassName
        const className = index === 0 ?
            'color-select-button selected' :
            'color-select-button';

        // Color
        const colorCode = firstItemInGroup.ProductColorCode ?
            firstItemInGroup.ProductColorCodeRGB :
            'transparent';
       
            // HTML Markup
            html += '<a data-color-id=\'' + firstItemInGroup.ProductColorID + '\' class=\'' + className + '\'> ';
            html += '<span class=\'title-and-tick\'>' + title + '</span> ';
            //html += '<i class=\'fa fa-lg fa-check-circle color-tick\'></i> ';
            html += '<span class=\'color-box\' style=\'background-color:' + colorCode + '\'></span> ';
            html += '</a> ';
        }
      
    });
    $('#colorList').html(html);

    // Hide color panel if there is no color
    const colorIds = Object.keys(groupedByColorId);
    if (colorIds.length === 1 &&
        groupedByColorId[colorIds[0]][0].ProductColorID === 0) {
        $('.colors-wrapper').hide();
    }

    LoadWarranties();
    colorClickHandler();
}

function LoadWarranties() {
    const selectedColorID = selectedColorId();
    let html = '';
    const data = getData();
    const grouped = _.chain<Price>(data)
        .filter(x =>  x.ProductColorID === selectedColorID)
        .groupBy(x => x.WarrantyID)
        //.sortBy(x => x[0].CalculatedPrice)
        .sortBy(x => WarrantySort(x[0].WarrantyID))
        .value();

    function WarrantySort(warranttId) {
        let priceList = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i].WarrantyID == warranttId) {
                priceList.push(data[i].CalculatedPrice);
            }
        }
        priceList.sort(function (a, b) { return b - a });
        return priceList[0];
    }
    let index = 0;
    if (grouped.length > 1) {
        $.each(grouped, (i, item) => {
            const currentItem = item[0];

            // Title
            let title = 'بدون گارانتی';
            if (currentItem.WarrantyID > 0) {
                let prefix = '';
                if (currentItem.WarrantyTitle != null && !currentItem.WarrantyTitle.includes("گارانتی")) {
                    prefix = 'گارانتی ';
                }
                title = prefix + currentItem.WarrantyTitle;
            }

            // ClassName
            const className = index === 0 ? 'warranty-select-button selected' : 'warranty-select-button';

            // HTML Markup
            html += '<div class=\'warranty-item\'> ';
            html += '<a data-warranty-id=\'' + currentItem.WarrantyID + '\' class=\'' + className + '\'> ';
            html += '<i class=\'radio-button-select warranty-tick\'></i> ';
            html += '<i class=\'radio-button-deselect warranty-untick\'></i> ';
            html += '<span>' + title + '</span> ';
            if (currentItem.WarrantyTooltip != null && currentItem.WarrantyTooltip.length > 0) {
                html += '<i class="fa fa-question-circle-o fa-flip-horizontal" style="color: #616161;margin-right: 5px;" title=\'' +
                    currentItem.WarrantyTooltip +
                    '\'></i>';
            }
            html += '</a> ';

            // Warranty Link
            if (currentItem.WarrantyLink !== null) {
                html += '<a target=\'_blank\' class=\'warranty-link\' href=\'' + currentItem.WarrantyLink + '\'> ';
                //html += '<i class=\'fa fa-lg fa-external-link-square\'></i> ';
                html += '</a> ';
            }

            html += '</div> ';
            index++;
        });
    } else {
        $.each(grouped, (i, item) => {
            const currentItem = item[0];

            // Title
            let title = 'بدون گارانتی';
            if (currentItem.WarrantyID > 0) {
                let prefix = '';
                if (currentItem.WarrantyTitle !=null && !currentItem.WarrantyTitle.includes("گارانتی")) {
                    prefix = 'گارانتی ';
                }
                title = prefix + currentItem.WarrantyTitle;
            }

            // ClassName
            const className = index === 0 ? 'warranty-select-button selected' : 'warranty-select-button';

            // HTML Markup
            html += '<div class=\'warranty-item\'> ';
            html += '<a data-warranty-id=\'' + currentItem.WarrantyID + '\' class=\'' + className + '\'> ';
            html += '<span>' + title + '</span>';
            if (currentItem.WarrantyTooltip!=null && currentItem.WarrantyTooltip.length>0) {
                html += '<i class="fa fa-question-circle-o fa-flip-horizontal" style="color: #616161;margin-right: 5px;" title=\'' +
                    currentItem.WarrantyTooltip +
                    '\'></i>';
            }
            html += '</a> ';

            // Warranty Link
            if (currentItem.WarrantyLink !== null) {
                html += '<a target=\'_blank\' class=\'warranty-link\' href=\'' + currentItem.WarrantyLink + '\'> ';
                //html += '<i class=\'fa fa-lg fa-external-link-square\'></i> ';
                html += '</a> ';
            }

            html += '</div> ';
            index++;
        });
    }

    $('#warrantyList').html(html);
    LoadSellers();
    warrantyClickHandler();
}

function LoadSellers() {
    const selectedColorID = selectedColorId();
    const selectedWarrantyID = selectedWarrantyId();
    let html = '';
    const data = getData();
    if (!data) return;

    const grouped = _.chain<Price>(data)
        .filter(x => x.WarrantyID === selectedWarrantyID && x.ProductColorID === selectedColorID)
        .groupBy(x =>  x.ShopID)
        .sortBy(x => x[0].CalculatedPrice)
        .value();

    let index = 0;
    $.each(grouped, (i, item) => {
        const currentItem = item[0];
        const className = index === 0 ? 'seller-select-button selected' : 'seller-select-button';

        html += '<div class=\'seller-item\'> ';
        html += '<a data-seller-id=\'' + currentItem.ShopID + '\' class=\'' + className + '\'> ';
        html += '<i class=\'seller-tick\'></i> ';
        html += '<i class=\'seller-untick\'></i> ';
        html += '<span>' + currentItem.ShopTitle + '</span> ';
        html += '</a> ';
        html += '</div> ';
        index++;
    });

    $('#sellersList').html(html);
    LoadVariations();
    sellerClickHandler();
}

function LoadVariations() {
    const selectedColorID = selectedColorId();
    const selectedWarrantyID = selectedWarrantyId();
    const selectedSellerID = selectedSellerId();
    let html = '';
    const data = getData();
    const filtered = data
        .filter(x => x.ProductColorID === selectedColorID &&
            x.WarrantyID === selectedWarrantyID &&
            x.ShopID === selectedSellerID);
    let index = 0;

    if (filtered.length > 1) {
        $.each(filtered, (i, item) => {
            const className = index === 0 ? 'variation-select-button selected' : 'variation-select-button';
            const priceDescription = item.PriceDescription ?
                item.PriceDescription :
                '-';

            html += '<div class=\'variation-item\'> ';
            html += '<a data-price-id=\'' + item.ID + '\' class=\'' + className + '\'> ';
            html += '<i class=\'radio-button-select variation-tick\'></i> ';
            html += '<i class=\'radio-button-deselect variation-untick\'></i> ';
            html += '<span>' + priceDescription + '</span> ';
            html += '</a> ';
            html += '</div> ';
            index++;
        });
    } else {
        $.each(filtered, (i, item) => {
            const className = index === 0 ? 'variation-select-button selected' : 'variation-select-button';
            const priceDescription = item.PriceDescription ?
                item.PriceDescription :
                '-';

            html += '<div class=\'variation-item\'> ';
            html += '<a data-price-id=\'' + item.ID + '\' class=\'' + className + '\'> ';
            html += '<span>' + priceDescription + '</span> ';
            html += '</a> ';
            html += '</div> ';
            index++;
        });
    }
    
    $('#variationList').html(html);

    // Hide panel if there is no description
    if (Object.keys(filtered).length === 1 && _.find(filtered, x => !x.PriceDescription)) {
        $('.variation-wrapper').hide();
    } else {
        $('.variation-wrapper').show();
    }

    UpdatePrice();
    UpdateRegistryMeta();
    UpdateExpressShipping();
    UpdateGovermentId();
    variationClickHandler();
}

function UpdateRegistryMeta() {
    const selectedPrice = getSelectedPrice();
    const value = selectedPrice.PriceDescription && selectedPrice.PriceDescription.includes("همراه با کد ریجستری")
        ? "registered"
        : "not_registered";
    $('meta[name="registry"]').attr("content", value);
}

function UpdateExpressShipping() {
    const selectedPrice = getSelectedPrice();
    if (selectedPrice.ExpressShipping)
        $('p.express-shipping').show();
    else
        $('p.express-shipping').hide();
}

function UpdateGovermentId() {
    const selectedPrice = getSelectedPrice();
    if (selectedPrice.GovId != null && selectedPrice.GovId.length > 0) {
        $('.gov-wrapper #variationList').text(selectedPrice.GovId);
        $('.gov-wrapper').show();
    } else {
        $('.gov-wrapper').hide();
    }
}

function UpdatePrice() {
    const selectedPrice = getSelectedPrice();
    if (selectedPrice === undefined) return;
    $('#hfdSelectedPriceId').val(selectedPriceId());

    const quantity = +$('.order-count > span').text();
    const price = selectedPrice.CalculatedPrice * quantity;
    const originalPrice = selectedPrice.Price * quantity;

    $('#lblPrice').text(Helpers.Utils.numberWithCommas(price) + ' تومان');
    $('#lblOriginalPrice').text(Helpers.Utils.numberWithCommas(originalPrice));

    $('.price-wrapper').removeClass('display-discount');
    if (selectedPrice.HasDiscount) {
        $('.price-wrapper').addClass('display-discount');
    }
}

function selectedColorId() {
    let returnValue = $('.color-select-button.selected').data('color-id');
    if (returnValue === undefined) {
        returnValue = 0;
    }

    return returnValue;
}

function selectedWarrantyId() {
    return $('.warranty-select-button.selected').data('warranty-id');
}

function selectedSellerId() {
    return $('.seller-select-button.selected').data('seller-id');
}

function selectedPriceId() {
    return $('.variation-select-button.selected').data('price-id');
}

function getSelectedPrice() {
    const data = getData();
    return _.find<Price>(data, x => x.ID === selectedPriceId());
}

function getData(): Price[] {
    const data = $('#hfdPrices').val() && $('#hfdPrices').val().toString()||null;
    if (!data || !data.length) return;

    return JSON.parse(data);
}

const initPrice = () => {
    orderCountClickHandler();
    LoadColors();
    LoadSellers();
};

export {
    initPrice
};
